import type { TourState } from '../store';

export const hasInitialTourCreatorState =
  (uuid: string) => (state: TourState) =>
    state.tourCreator.tours.hasOwnProperty(uuid);

export const selectIsCapturing = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].isCapturing;

export const selectTourId = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].tourId;

export const selectTourFrames = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].tourFrames;

export const selectIsReadyToCapture = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].isReadyToCapture;

export const selectIsCapturingFinished = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].isCapturingFinished;

export const selectCanFinishCapturing = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].canFinishCapturing;

export const selectIsCaptureStarted = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].isCaptureStarted;

export const selectIsCaptureButtonDisabled =
  (uuid: string) => (state: TourState) =>
    state.tourCreator.tours[uuid].isCaptureButtonDisabled;

export const selectFramesLoading = (uuid: string) => (state: TourState) =>
  state.tourCreator.tours[uuid].framesLoading;

export const selectIsCaptureSnapshotPending =
  (uuid: string) => (state: TourState) =>
    state.tourCreator.tours[uuid].isCaptureSnapshotPending;

export const selectIsShowingDimensionPanel =
  (uuid: string) => (state: TourState) =>
    state.tourCreator.tours[uuid]?.isShowingDimensionPanel;
